import React from 'react'
import { useNavigate} from "react-router-dom";


import {Card,CardBody,Col, Container,Input,InputGroup,InputGroupText,Row,Table,Button,Nav,NavItem,NavLink,} from "reactstrap";

const SubmittedCandidate = () => {
    const navigate = useNavigate();
  const jobId = "JD1023"; 

  const submittedCondidateData=[
    {CandidateID:"C-001", CandidateName:"Name", Email:"name@gmail.com",Mobile:"9xxxxxxxxx", SubmittedOn:"dd/mm/yyy", status:"Screening", Remarks:"---"},
    {CandidateID:"C-002", CandidateName:"Name", Email:"name@gmail.com",Mobile:"9xxxxxxxxx", SubmittedOn:"dd/mm/yyy", status:"Selected",Remarks:"Interview Scheduled"},
    {CandidateID:"C-003", CandidateName:"Name", Email:"name@gmail.com",Mobile:"9xxxxxxxxx", SubmittedOn:"dd/mm/yyy", status:"Selected",Remarks:"Rejected"}
  ]    
  return (
    <div className="pt-4" style={{ backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
     <Container fluid className="p-5" style={{ background: "#f8f9fa" }}>
       <Row className="mt-3">
         <Col>
         <p>View Job Postings/ JD1023/ View Post</p>
          <h2 style={{ color: "#222222" }}>View Job Post</h2>
         </Col>     

         <Col className='text-end'>
         <Button  className="px-4 p-2 rounded-4 text-white" style={{background:"#006438"}}
          onClick={() => navigate(`/add-candidate/${jobId}`)}
          >+Add Candidate
        </Button>
         </Col>

        </Row>

      {/* Tabs */}
      <Nav tabs className="mb-4">
        <NavItem>
       <NavLink onClick={() => navigate(`/view-job/${jobId}`)}>
        Overview
       </NavLink>

        </NavItem>
        <NavItem>
          <NavLink>Submitted Candidates</NavLink>
        </NavItem>
      </Nav>

      <Row>
            <Col className="d-flex gap-3 align-items-center">
              <InputGroup
                size="sm"
                className="elbert-search-group"
                style={{ width: "348px" }}
              >
                <InputGroupText>
                  <span className="fa fa-search fs-6"></span>
                </InputGroupText>

                <Input
                  placeholder="Search by candidate name"
                  className="elbert-search fs-6"
                />

              </InputGroup>

              <Input
                type="select"
                className="elbert-search"
                style={{ width: "125px", marginLeft: "16px" }}
              >
                <option value="">Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </Input>
            </Col>
          </Row>

          {/* Job Postings Table */}
          <Row className="mt-4 mx-0">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                    <thead>
                      <tr>
                        <th>Candidate ID</th>
                        <th>Candidate Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Submitted On</th>
                        <th>Status</th>
                        <th>Remarks</th>                
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {submittedCondidateData.map((data) => (
                        <tr key={data.CandidateID}>
                          <td>{data.CandidateID}</td>
                          <td>{data.CandidateName}</td>
                          <td>{data.Email}</td>
                          <td>{data.Mobile}</td>
                          <td>{data.SubmittedOn}</td>
                          <td >{data.status === "Screening"? "Screening":"Selected"}</td>
                          <td>{data.Remarks}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <i
                                className="fa-solid fa-eye action-icon"
                                title="View"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate(`/view-candidateprogerss/${jobId}`)}

                                // onClick={() => navigate("/job-details")}
                              ></i>
                           </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
      
    </Container>
    </div>
  )
}

export default SubmittedCandidate